import React from "react";

const Fragment = ({ className }) => {
  return (
    <svg
      class="svg-icon"
      className={className}
      width={180}
      height={200}
      viewBox="0 0 1024 1024"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill="#66788D"
        d="M251.105569 670.32419a20.003325 20.003325 0 0 1-14.896093-6.38404l-133.213632-132.78803a21.280133 21.280133 0 0 1-5.958438-14.896093 22.131338 22.131338 0 0 1 5.958438-15.321696L246.849543 357.506234a21.280133 21.280133 0 0 1 30.217789 0 21.280133 21.280133 0 0 1 0 29.792187l-127.680798 127.680798 116.615129 119.168744a20.428928 20.428928 0 0 1 0 29.792187 20.003325 20.003325 0 0 1-14.896094 6.38404zM770.340815 670.32419a20.003325 20.003325 0 0 1-14.896093-6.38404 20.428928 20.428928 0 0 1 0-29.792187l117.891936-117.891936-127.680798-127.680798a21.280133 21.280133 0 0 1 0-29.792187 21.280133 21.280133 0 0 1 30.217789 0l143.853699 143.428097a22.131338 22.131338 0 0 1 5.958438 15.321696 21.280133 21.280133 0 0 1-5.958438 14.896093l-134.49044 131.511222a20.003325 20.003325 0 0 1-14.896093 6.38404zM434.114713 738.420615a24.259352 24.259352 0 0 1-7.660848 0 20.85453 20.85453 0 0 1-12.342477-27.23857L567.753948 297.921862a21.280133 21.280133 0 1 1 39.581048 14.896093L453.692436 723.524522a20.428928 20.428928 0 0 1-19.577723 14.896093z"
      />
    </svg>
  );
};

export default Fragment;
